import React from 'react';
import {
  Container,
  Stack,
  Divider,
  Box,
  Button,
  FormControl,
  Paper,
  Grid,
  Typography
} from '@mui/material';
import {
  Autocomplete,
  NoRowsOverlay,
  Datas,
  AprovacoesCheckbox
} from '../../../components';
import api from '../../../services/api';
import * as yup from 'yup';
import { useStoreState, useStoreActions, reducer } from 'easy-peasy';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import DadosGerais from './DadosGerais';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { CSVDownload } from 'react-csv';
import { tagsRel, tagsRelForuns, opcaoTematica, listaODS } from './static';
import { removerQuebrasDeLinha } from '../../../utils/removerQuebraDeLinha';

const Tema07 = () => {
  let startLoading = useStoreActions(actions => actions.nav.startLoading);
  let stopLoading = useStoreActions(actions => actions.nav.stopLoading);
  let user = useStoreState(state => state.auth.user);

  const [empresas, setEmpresas] = React.useState([]);
  const [ano, setAno] = React.useState(new Date().getFullYear() - 1);
  const [csvData, setCsvData] = React.useState([]);
  const [csvDataForuns, setCsvDataForuns] = React.useState([]);

  const schema = yup
    .object({
      empresaId: yup.number().nullable().label('Selecione a empresa').required()
    })
    .required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });

  const {
    handleSubmit,
    watch,
    formState: { isDirty, isSubmitting }
  } = useFormRef;

  const watchEmpresaId = watch('empresaId');

  const onChangeAno = (event, ano) => {
    setAno(ano);
  };

  const loadEmpresas = async mount => {
    startLoading();
    if (mount.isMounted)
      try {
        let matrizes = (
          await api.http.get(
            '/empresas/' +
              (user.roleId == 'admin' ? '?all=1&matriz=1' : '?matriz=1')
          )
        ).data;
        setEmpresas(matrizes);
        stopLoading();
      } catch (error) {
        stopLoading({
          message: error.toString(),
          severity: 'error'
        });
      }
  };
  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    loadEmpresas(mount);
    return () => {
      mount.isMounted = false;
    };
  }, []);

  function extrairDataHora(dateTimeStr) {
    const dateObj = new Date(dateTimeStr);
    const year = dateObj.getFullYear().toString();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObj.getDate().toString().padStart(2, '0');
    const date = `${day}-${month}-${year}`;
    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');
    const seconds = dateObj.getSeconds().toString().padStart(2, '0');
    const time = `${hours}:${minutes}:${seconds}`;
    return date + ' ' + time;
  }
  function extrairData(dateStr) {
    const date = new Date(dateStr);
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${month}-${year}`;
  }
  const exportDadosGerais = async () => {
    startLoading();
    try {
      const dados = (await api.http.get('/07/desenvolvimento-territorios'))
        .data;
      console.log(dados);
      const dadosCsv = dados.map((data, index) => {
        return {
          cnpj: data?.empresa?.cnpj,
          empresa: removerQuebrasDeLinha(data.empresa.nome),
          ano: data.ano,
          possuiMapeamento: data?.possuiMapeamento ? 'SIM' : 'NÃO',
          fazParteEstrategia: data?.fazParteEstrategia ? 'SIM' : 'NÃO',
          priorizamTematica: data?.priorizamTematica
            ? opcaoTematica[data.priorizamTematica - 1].label
            : null,
          saude: data?.saude ? 'SIM' : 'NÃO',
          educacao: data?.educacao ? 'SIM' : 'NÃO',
          infraestruturaUrbana: data?.infraestruturaUrbana ? 'SIM' : 'NÃO',
          saneamentoBasico: data?.saneamentoBasico ? 'SIM' : 'NÃO',
          segurancaPublica: data?.segurancaPublica ? 'SIM' : 'NÃO',
          direitosHumanos: data?.direitosHumanos ? 'SIM' : 'NÃO',
          meioAmbiente: data?.meioAmbiente ? 'SIM' : 'NÃO',
          diversidadeInclusao: data?.diversidadeInclusao ? 'SIM' : 'NÃO',
          geracaoDeRenda: data?.geracaoDeRenda ? 'SIM' : 'NÃO',
          diversificacaoEconomica: data?.diversificacaoEconomica
            ? 'SIM'
            : 'NÃO',
          outro: removerQuebrasDeLinha(data?.outro),
          //Mao de obra
          incentivaContratacaoLocal: data?.incentivaContratacaoLocal
            ? 'SIM'
            : 'NÃO',
          metasFormais: data?.metasFormais ? 'SIM' : 'NÃO',
          contratadosLocalmente: data?.contratadosLocalmente,
          locaisProprios: data?.locaisProprios,
          locaisTerceiros: data?.locaisTerceiros,
          metaCotratacaoEmpresa: data?.metaCotratacaoEmpresa,
          prazoMetaCotratacao: data?.prazoMetaCotratacao
            ? extrairData(data.prazoMetaCotratacao)
            : null,
          //ODS
          empresaAdota: data?.empresaAdota ? 'SIM' : 'NÃO',
          empresaIncentiva: data?.empresaIncentiva ? 'SIM' : 'NÃO',
          acoesImplementadas: removerQuebrasDeLinha(data?.acoesImplementadas),
          ordemOds: data?.ordemOds.map(ods => listaODS[ods - 1].label),
          //Formaçao e desenvolvimento
          formacaoLiderancaInterno: data?.formacaoLiderancaInterno
            ? 'SIM'
            : 'NÃO',
          metaFormacaoInterno: data?.metaFormacaoInterno,
          tematicasInterno: removerQuebrasDeLinha(data?.tematicasInterno),
          formacaoPublicoExterno: data?.formacaoPublicoExterno ? 'SIM' : 'NÃO',
          metaFormacaoExterno: data?.metaFormacaoExterno,
          tematicasExterno: removerQuebrasDeLinha(data?.tematicasExterno),
          observacao: data.observacao ? removerQuebrasDeLinha(data.observacao) : null,
          createdAt: data.createdAt ? extrairDataHora(data.createdAt) : null,
          updatedAt: data.updatedAt ? extrairDataHora(data.updatedAt) : null
        };
      });

      if (dadosCsv.length == 0) {
        stopLoading({
          message: 'Nenhum registro encontrado.',
          severity: 'error'
        });
      } else {
        setCsvData([tagsRel, ...dadosCsv]);
        stopLoading();
      }
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };
  const exportDadosForuns = async () => {
    startLoading();
    try {
      const dados = (await api.http.get('/07/lista-forum-conselho')).data;
      const dadosCsvForuns = dados.map(data => {
        return {
          cnpj: data?.empresa?.cnpj,
          empresa: data?.empresa?.nome,
          ano: data?.ano,
          nomeForum: data?.nomeForum,
          participaAtivamente: data?.participaAtivamente ? 'SIM' : 'NÃO',
          createdAt: data.createdAt ? extrairDataHora(data.createdAt) : null,
          updatedAt: data.updatedAt ? extrairDataHora(data.updatedAt) : null
        };
      });

      if (dadosCsvForuns.length == 0) {
        stopLoading({
          message: 'Nenhum registro encontrado.',
          severity: 'error'
        });
      } else {
        setCsvDataForuns([tagsRelForuns, ...dadosCsvForuns]);
        stopLoading();
      }
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  return (
    <Container>
      <Paper
        variant="outlined"
        className="center-box"
        sx={{
          textAlign: 'center',
          px: 4,
          pt: 2,
          pb: 3,
          m: 5
        }}
      >
        <Divider>
          <h3>Dados básicos</h3>
        </Divider>
        <Box component="form" autoComplete="off">
          <Stack direction="row" spacing={2}>
            <FormControl fullWidth>
              <Autocomplete
                field="empresaId"
                useFormRef={useFormRef}
                options={empresas}
                getOptionLabel={empresa =>
                  empresa.nome + ' (' + empresa.cnpj + ')'
                }
                schema={schema}
              />
            </FormControl>
            <Datas onChange={onChangeAno} value={ano} />
          </Stack>
          <Stack direction="row" spacing={2}>
            <AprovacoesCheckbox />
          </Stack>
          {['admin', 'gestor', 'preenchedorSso'].includes(user.roleId) && (
            <Stack direction="row" spacing={2} mt={2}>
              <Button
                variant="contained"
                onClick={exportDadosGerais}
                sx={{ height: 45 }}
              >
                <FileDownloadIcon /> Exportar Dados Gerais (CSV)
              </Button>
              {csvData && csvData.length > 0 && (
                <CSVDownload
                  data={csvData}
                  headers={tagsRel.headers}
                  separator=";"
                  target="_blank"
                />
              )}

              <Button
                variant="contained"
                onClick={exportDadosForuns}
                sx={{ height: 45 }}
              >
                <FileDownloadIcon /> Exportar Dados Foruns/Conselhos (CSV)
              </Button>
              {csvDataForuns && csvDataForuns.length > 0 && (
                <CSVDownload
                  data={csvDataForuns}
                  headers={tagsRelForuns.headers}
                  separator=";"
                  target="_blank"
                />
              )}
            </Stack>
          )}
        </Box>
      </Paper>

      {watchEmpresaId && (
        <>
          <Paper
            variant="outlined"
            className="center-box"
            sx={{
              textAlign: 'center',

              pt: 2,
              pb: 3,
              m: 5
            }}
          >
            <DadosGerais ano={ano} watchEmpresaId={watchEmpresaId} />
          </Paper>
        </>
      )}
    </Container>
  );
};

export default Tema07;
